/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuiviApprenantFichierDto
 */
export interface SuiviApprenantFichierDto {
    /**
     * 
     * @type {number}
     * @memberof SuiviApprenantFichierDto
     */
    idsuiviApprenantFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviApprenantFichierDto
     */
    idsuiviApprenant?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviApprenantFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviApprenantFichierDto
     */
    idtypeSuiviFichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviApprenantFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the SuiviApprenantFichierDto interface.
 */
export function instanceOfSuiviApprenantFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviApprenantFichierDtoFromJSON(json: any): SuiviApprenantFichierDto {
    return SuiviApprenantFichierDtoFromJSONTyped(json, false);
}

export function SuiviApprenantFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviApprenantFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsuiviApprenantFichier': !exists(json, 'idsuiviApprenantFichier') ? undefined : json['idsuiviApprenantFichier'],
        'idsuiviApprenant': !exists(json, 'idsuiviApprenant') ? undefined : json['idsuiviApprenant'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : json['idtypeSuiviFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function SuiviApprenantFichierDtoToJSON(value?: SuiviApprenantFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsuiviApprenantFichier': value.idsuiviApprenantFichier,
        'idsuiviApprenant': value.idsuiviApprenant,
        'idfichier': value.idfichier,
        'idtypeSuiviFichier': value.idtypeSuiviFichier,
        'fileName': value.fileName,
    };
}

